import { FC } from 'react'
import classNames from 'classnames'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'

import useDesignConstants from '../../hooks'

import './styles.scss'

const TagsMenu: FC = () => {
  const { menuItems } = useDesignConstants()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleNavigation = (navigateTo: string) => navigate(navigateTo)

  return (
    <div className="tags-design-menu">
      <div className="tags-design-menu__title">
        {t('tenantDesign.menu.title')}
      </div>
      <hr className="tags-design-menu__separator" />
      <div className="tags-design-menu__menu-options">
        {menuItems &&
          menuItems.map((menuItem) => (
            <div
              key={menuItem.index}
              className={classNames(
                'tags-design-menu__menu-options__option',
                menuItem.value === 'tags' &&
                  'tags-design-menu__menu-options__option active'
              )}
              onClick={() => handleNavigation(`../${menuItem.value}`)}
            >
              {menuItem.name}
            </div>
          ))}
      </div>
    </div>
  )
}

export default TagsMenu
